import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './News.css';
import Axios from 'axios';
import Config from '../../Core/Config.js';
import {framework} from 'saffroncodejs';
var PageManager = framework.PageManager ;

class SingleNews extends React.Component {
  constructor(props) {
    super(props);
    var urlParams = PageManager.decodePageParams(props);
    this.currentNewsId = this.encodeSodurId(urlParams[0]);
    this.state = {
      news:[{ companyName: 'شرکت سامان نگار ایرانیان', addressCo: 'تهران', faxCo: '84325', telCo: '84325', locationCo: '627.2238657537844 M' }]
    };
    this.state.news=[];
    this.loadDetail();
}
encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        var urlParams = PageManager.decodePageParams(props);
        this.currentNewsId = this.encodeSodurId(urlParams[0]);
        
        this.loadDetail();
    }
    loadDetail(){
        var newsId=parseInt(this.currentNewsId,10);
    Axios.get(Config.domain_pic+"GetNewsInfo?"+
            "UserId="+0+"&LanguageBaseId="+11+"&NewsId="+newsId
        )
        .then((result) => {
            // console.log("result.news: ", JSON.stringify(result.data));
            this.setState({ news: result.data, isloading: false });
  }
        )
  }
  render() {
    const { news } = this.state;
    return (

      <div>
          <br/>
        <Container className="main alignRight news_single">
                <Row>
                    
                    {news.map((newsItem) => 
                        <Col sm='12'>
                            <h4>{newsItem.Title}</h4>
                            {/* <h6>{newsItem.CreatedDate}</h6> */}
                            <p>{newsItem.NewsBreif}</p>
                            <img alt="" src={'http://mobapp.novininsurance.com/UploadImages/News/'+newsItem.FileName1+'.jpg'} className="thumbnail-post"/>
                            <p>
                                {newsItem.Context.replace(/\\n/g,'')}
                            </p>
                            </Col>
                     ) }
                    
                </Row>
            </Container>
        <br/>
      </div>
    );
  }
}
export default SingleNews;


// WEBPACK FOOTER //
// ./src/components/News/SingleNews.js